import React from "react";
import { Link, useLocation } from "react-router-dom";

const ChatHeader: React.FC = () => {
  const headers: {
    name: string;
    href: string;
  }[] = [
    { name: "Inbox", href: "/chat/e" },
    { name: "Community", href: "/ecobook" },
  ];

  const { pathname } = useLocation();

  return (
    <div className="w-[50%] lg:w-[30%] lg:mt-0 mt-10">
      <ul className="lg:bg-white rounded w-full lg:shadow-sm flex h-10 text-center items-center">
        {headers.map((header) => (
          <li
            className={`ecoHeader ${
              pathname === header.href ? "activeLink" : "ecoHeader"
            }`}
            key={header.name}
          >
            <Link to={header.href}>{header.name}</Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ChatHeader;
